var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 85,
    viewBox: "0 0 109 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8333 72.8571V75.8929C90.8333 80.9227 86.7666 85 81.75 85H9.08333C4.06668 85 0 80.9227 0 75.8929V27.3214C0 22.2916 4.06668 18.2143 9.08333 18.2143H12.1111V57.6786C12.1111 66.048 18.9024 72.8571 27.25 72.8571H90.8333ZM109 57.6786V9.10714C109 4.07734 104.933 0 99.9167 0H27.25C22.2334 0 18.1667 4.07734 18.1667 9.10714V57.6786C18.1667 62.7084 22.2334 66.7857 27.25 66.7857H99.9167C104.933 66.7857 109 62.7084 109 57.6786ZM48.4444 18.2143C48.4444 23.2441 44.3778 27.3214 39.3611 27.3214C34.3445 27.3214 30.2778 23.2441 30.2778 18.2143C30.2778 13.1845 34.3445 9.10714 39.3611 9.10714C44.3778 9.10714 48.4444 13.1845 48.4444 18.2143ZM30.2778 45.5357L40.7832 35.0027C41.67 34.1137 43.1078 34.1137 43.9947 35.0027L51.4722 42.5L77.1166 16.7885C78.0033 15.8994 79.4411 15.8994 80.3281 16.7885L96.8889 33.3929V54.6429H30.2778V45.5357Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3cdbb815235d46565a29a735f565004a.svg";
export { ForwardRef as ReactComponent };